import Vue from "vue"
import Router from "vue-router"
import Public from "./components/Public.vue"
import PublicHome from "./views/PublicHome.vue"
import PublicLokalita from "./views/PublicLokalita.vue"
import Private from "./components/Private.vue"
import Home from "./views/Home.vue"
import Login from "./views/Login.vue"
import Users from "./views/Users.vue"
import Report from "./views/Report.vue"
import Merania from "./views/Merania.vue"
import Lokality from "./views/Lokality.vue"
import Lokalita from "./views/Lokalita.vue"
import Body from "./views/Body.vue"
import Bod from "./views/Bod.vue"
import Stanice from "./views/Stanice.vue"
import Uzemia from "./views/Uzemia.vue"
import Stanica from "./views/Stanica.vue"
import Insar from "./views/Insar.vue"
import Importxls from "./views/Importxls.vue"
import Export from "./views/Export.vue"
import Chart from "./views/Chart.vue"
import ChartsHpv from "./views/ChartsHpv.vue"
import ChartsHpvq from "./views/ChartsHpvq.vue"
import ChartsGeo from "./views/ChartsGeo.vue"
import ChartsInk from "./views/ChartsInk.vue"
import ChartsKomb from "./views/ChartsKomb.vue"
import ChartsMikroniv from "./views/ChartsMikroniv.vue"
import ChartsStabskal from "./views/ChartsStabskal.vue"

Vue.use(Router)

export default new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: { name: "home" }
    },
    {
      path: "/public",
      name: "public",
      component: Public,
      children: [
        {
          path: "/public/",
          name: "PublicHome",
          component: PublicHome
        },
        {
          path: "/public/lokalita/:id",
          name: "lokalitaPublic",
          component: PublicLokalita,
          props: true
        }
      ]
    },
    {
      path: "/private",
      name: "private",
      component: Private,
      children: [
        { path: "/", name: "home", component: Home },
        { path: "/login", name: "login", component: Login },
        { path: "/users", name: "users", component: Users },
        { path: "/lokality", name: "lokality", component: Lokality },
        {
          path: "/lokalita/:id",
          name: "lokalita",
          component: Lokalita,
          props: true
        },
        { path: "/body", name: "body", component: Body },
        { path: "/bod/:id", name: "bod", component: Bod },
        { path: "/report/:typ", name: "report", component: Report },
        { path: "/merania/:typ", name: "merania", component: Merania },
        { path: "/insar/:id", name: "insar", component: Insar, props: true },
        { path: "/stanice", name: "stanice", component: Stanice },
        {
          path: "/stanica/:lokalitaId/:id",
          name: "stanica",
          component: Stanica
        },
        { path: "/uzemia", name: "uzemia", component: Uzemia },
        { path: "/importxls", name: "importxls", component: Importxls },
        { path: "/export", name: "export", component: Export },
        { path: "/chart/:typ", name: "chart", component: Chart, props: true },
        { path: "/charts/hpv", name: "chartsHpv", component: ChartsHpv },
        { path: "/charts/hpvq", name: "chartsHpvq", component: ChartsHpvq },
        { path: "/charts/geo", name: "chartsGeo", component: ChartsGeo },
        { path: "/charts/ink", name: "chartsInk", component: ChartsInk },
        { path: "/charts/komb", name: "chartsKomb", component: ChartsKomb },
        {
          path: "/charts/mikroniv",
          name: "chartsMikroniv",
          component: ChartsMikroniv
        },
        {
          path: "/charts/stabskal",
          name: "chartsStabskal",
          component: ChartsStabskal
        }
      ]
    }
  ]
})
